import {firestore, functions} from "../../firebase/firebase";
import {CardElement} from "@stripe/react-stripe-js";
import {collect, disconnect, discover} from "../terminal";

export default (state, props,paymentMethodId) => {
	return new Promise(async (resolve, reject) => {
		let credit = false;
		if (props.auth.type.endsWith("Admin")) {
			return resolve({receipt: null, charge: null, method: "Credit", methodSource: null});
		}
		const agentId = props.auth.agent || props.auth.uid;
		const doc = await firestore.doc("agents/" + agentId).get();
		credit = doc.exists && doc.data() ? doc.data().credit || false : false;
		if (state.epay) {          // ← bandera que ya llevas en Add.state
			return resolve({
			  receipt     : paymentMethodId,          // transactionId
			  charge      : null,
			  method      : "ePay",             // se guardará en Firestore
			  methodSource: "ePayPolicy"
			});
		  }
		if (props.configuration === "credit") {
			return resolve({receipt: null, charge: null, method: "Credit", methodSource: null});
		}
		if (credit) {
			return resolve({receipt: null, charge: null, method: "Credit", methodSource: null});
		}

	
		   
	
		return reject({
			title: "No Configuration",
		});
	});
}